import { createAsyncThunk } from "@reduxjs/toolkit";

import { axiosInstance as axios } from "../../../../api/axiosInstance";
import { showSnackbar } from "../../../reducers/snackbar/snackbarSlice";

type meta = {
  page: number,
  pageSize: number
}

export const getLoginActivity = createAsyncThunk(
  "getLoginActivity",
  async(meta: meta, thunkAPI) => {
    const { dispatch, rejectWithValue } = thunkAPI;
    const pageSize = meta.pageSize;
    const page = meta.page;
    return axios.get(`/api/v1/auth/login-activity?pageSize=${pageSize}&page=${page}`)
      .then((resp) => {
        return resp.data;
      })
      .catch(() => {
        const errorMessage = "There was an error getting the login activity.";

        dispatch(showSnackbar({
          message: errorMessage,
          variant: "error"
        }));

        return rejectWithValue(errorMessage);
      });
  }
);
